import { useSetQuestionLikeMutation } from './mobile/qna.gql.impl';

interface Props {
  onSuccess: () => void;
}
const useSetQuestionLike = ({ onSuccess }: Props) => {
  const { mutate: setLikeQuestionMutate } = useSetQuestionLikeMutation({
    onSuccess,
  });

  return {
    setLikeQuestionMutate,
  };
};

export default useSetQuestionLike;
